module.exports = __webpack_public_path__ + "static/media/gallery_17.98b318ef.jpg";